import { Box } from '@material-ui/core';
import { NotificationStatus } from '@nemuru-eng/js-api-client';

import { Icon } from '@/components/shared/components/Icon';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface NotificationStatusTagProps {
  status: NotificationStatus;
}
export const NotificationStatusTag = ({ status }: NotificationStatusTagProps) => {
  const { palette } = useCustomTheme();

  const iconByStatus = () => {
    switch (status) {
      case NotificationStatus.ACCEPTED:
      case NotificationStatus.CLICK:
      case NotificationStatus.DELIVERED:
      case NotificationStatus.PROCESSED:
      case NotificationStatus.OPEN:
      case NotificationStatus.BUFFERED:
        return { iconTitle: 'done', color: palette.success.main };
      case NotificationStatus.EXPIRED:
      case NotificationStatus.FAILED:
      case NotificationStatus.REJECTED:
        return { iconTitle: 'cancel', color: palette.error.main };
      default:
        return { iconTitle: 'hourglass_empty', color: palette.text.secondary };
    }
  };

  const icon = iconByStatus();

  return (
    <Box display={'flex'} flexDirection={'row'}>
      <Icon color={icon.color}>{icon.iconTitle}</Icon>
    </Box>
  );
};
